// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3ZWkh","rootCenter":"LoadMoreObserver_rootCenter__YMbT7","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1dAEs"};